module.exports = __webpack_public_path__ + "static/tada-34ed912180434a14e541d070f0097be2.svg";